import { Box, Typography } from '@mui/material';
import { memo, useMemo } from 'react';
import { PLAYER_STATUS } from '@/constants/player-constants';
import LottieIconComponent, { LOTTIE_ICONS } from '../lottie/LottieIconComponent';

const StatusIconComponent = memo(
    ({
        status = PLAYER_STATUS.OK,
        statusLevel,
        useLabel = false,
        hideOk = false,
        width = 60,
        height = 60,
    }) => {
        status = status ? status : PLAYER_STATUS.OK;

        if (hideOk && status === PLAYER_STATUS.OK) {
            return null;
        }

        // Determinar qué icono Lottie usar según el status y statusLevel
        const lottieIcon = useMemo(() => {
            // Caso especial para flecha
            if (status === 'arrow') {
                return LOTTIE_ICONS.RIGHT_ARROW;
            }

            switch (status) {
                case PLAYER_STATUS.OK:
                    return LOTTIE_ICONS.OK_STATUS;

                case PLAYER_STATUS.INJURED:
                    if (statusLevel === 1) {
                        return LOTTIE_ICONS.INJURED_RED;
                    } else if (statusLevel === 2) {
                        return LOTTIE_ICONS.INJURED_BLACK;
                    } else {
                        return LOTTIE_ICONS.EXTRADEPORTIVO;
                    }

                case PLAYER_STATUS.DOUBTFUL:
                    if (statusLevel === 1) {
                        return LOTTIE_ICONS.DOUBT_GREEN;
                    } else {
                        return LOTTIE_ICONS.DOUBT_ORANGE;
                    }

                case PLAYER_STATUS.SANCTIONED:
                    return LOTTIE_ICONS.RED_CARD;

                default:
                    return LOTTIE_ICONS.OK_STATUS;
            }
        }, [status, statusLevel]);

        // Obtener el label según el status
        const label = useMemo(() => {
            switch (status) {
                case PLAYER_STATUS.OK:
                    return 'Disponible';
                case PLAYER_STATUS.INJURED:
                    if (statusLevel === 1) {
                        return 'Lesionado';
                    } else if (statusLevel === 2) {
                        return 'Lesión de larga duración';
                    } else {
                        return 'Extradeportivo';
                    }
                case PLAYER_STATUS.DOUBTFUL:
                    if (statusLevel === 1) {
                        return 'Duda leve';
                    } else {
                        return 'Duda';
                    }
                case PLAYER_STATUS.SANCTIONED:
                    return 'Sancionado';
                case PLAYER_STATUS.APERCIBIDO:
                    return 'Apercibido';
                default:
                    return '';
            }
        }, [status, statusLevel]);

        if (!lottieIcon) {
            return null;
        }

        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5,
                }}
            >
                <LottieIconComponent
                    icon={lottieIcon}
                    width={`${width}px`}
                    height={`${height}px`}
                    loop={true}
                    autoplay={true}
                />
                {useLabel && <Typography sx={{ fontSize: '13px' }}>{label}</Typography>}
            </Box>
        );
    }
);

StatusIconComponent.displayName = 'StatusIconComponent';

export default StatusIconComponent;
